 import ApiService from "@/core/services/api.service";
 import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    async getNotasFiscais(context, dados) {
        if((!dados.pagina) || (!dados.quantidadePorPagina)) {
            dados.pagina = 1;
            dados.quantidadePorPagina = 25;
        }
        if (!JwtService.getToken()) throw new Error('Sessão expirada');
        ApiService.setHeader();
        const {data} = await ApiService.post("notasFiscais/access/listar", dados);
        return data;
    },
    postNotaFiscal(context, dados) {
        return new Promise(resolve => {
            if(JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("notasFiscais/access/salvar", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    deleteNotaFiscal(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("notasFiscais/access/excluir", { ID_NOTA_FISCAL: dados.id, componente: dados.componente }).then(({ data }) => {
                        resolve(data);
                });
            }
        });
    },
    async getNotaFiscalProdutos(context, dados){
        if (!JwtService.getToken()) throw new Error('Sessão expirada');
        ApiService.setHeader();
        const {data} = await ApiService.post("notasFiscais/access/listaNotaFiscalProdutos", dados);
        return data;
    },
    geraNotaFiscal(context, dados){
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                    ApiService.setHeader();
                    ApiService.post("notasFiscais/access/emitirNotaFiscal", dados).then(({ data }) => {
                            resolve(data);
                    });
                }
        });
    },
    listarNotaFiscal(context, dados){
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                    ApiService.setHeader();
                    ApiService.post("notasFiscais/access/listarNotaFiscalEmitida", dados).then(({ data }) => {
                            resolve(data);
                    });
                }
        });
    },
    cancelarNotaFiscal(context, dados){
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                    ApiService.setHeader();
                    ApiService.post("notasFiscais/access/cancelarNotaFiscalEmitida", dados).then(({ data }) => {
                            resolve(data);
                    });
                }
        });
    }

};

export default {
    state,
    actions,
    mutations,
    getters
};    
